module.exports = __webpack_public_path__ + "static/media/transmoor.0e1a207f.png";